var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCredentialsLight(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 22,
    viewBox: "0 0 24 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.87891 16.5C9.3977 16.5 10.6289 15.2688 10.6289 13.75C10.6289 12.2312 9.3977 11 7.87891 11C6.36013 11 5.12891 12.2312 5.12891 13.75C5.12891 15.2688 6.36013 16.5 7.87891 16.5Z",
    stroke: "#A1A1A1",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3431 21.4999C12.2231 20.3997 11.701 19.3826 10.877 18.6437C10.0531 17.9048 8.9853 17.4961 7.87856 17.4961C6.77182 17.4961 5.70405 17.9048 4.88012 18.6437C4.05619 19.3826 3.53411 20.3997 3.41406 21.4999",
    stroke: "#A1A1A1",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 8.5H23.5",
    stroke: "#A1A1A1",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 4.5H22.5C22.7652 4.5 23.0196 4.60536 23.2071 4.79289C23.3946 4.98043 23.5 5.23478 23.5 5.5V20.5C23.5 20.7652 23.3946 21.0196 23.2071 21.2071C23.0196 21.3946 22.7652 21.5 22.5 21.5H1.5C1.23478 21.5 0.98043 21.3946 0.792893 21.2071C0.605357 21.0196 0.5 20.7652 0.5 20.5V5.5C0.5 5.23478 0.605357 4.98043 0.792893 4.79289C0.98043 4.60536 1.23478 4.5 1.5 4.5H9.5",
    stroke: "#A1A1A1",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12 3C11.8619 3 11.75 2.88807 11.75 2.75C11.75 2.61193 11.8619 2.5 12 2.5",
    stroke: "#A1A1A1"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M12 3C12.1381 3 12.25 2.88807 12.25 2.75C12.25 2.61193 12.1381 2.5 12 2.5",
    stroke: "#A1A1A1"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M15 13.5H21",
    stroke: "#A1A1A1",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M15 16.5H18.5",
    stroke: "#A1A1A1",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 6C14.5 6.13261 14.4473 6.25979 14.3536 6.35355C14.2598 6.44732 14.1326 6.5 14 6.5H10C9.86739 6.5 9.74021 6.44732 9.64645 6.35355C9.55268 6.25979 9.5 6.13261 9.5 6V3C9.5 2.33696 9.76339 1.70107 10.2322 1.23223C10.7011 0.76339 11.337 0.5 12 0.5C12.663 0.5 13.2989 0.76339 13.7678 1.23223C14.2366 1.70107 14.5 2.33696 14.5 3V6Z",
    stroke: "#A1A1A1",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCredentialsLight);
export default __webpack_public_path__ + "static/media/credentials-light.44ed3417302598e61df9332ba46da09a.svg";
export { ForwardRef as ReactComponent };